export default __webpack_public_path__ + "static/mq-a7df88ca47f05d01a250628152813563.svg";